import { InitCookie } from '@patsnap/init-cookie';

export class InitCookieService {
    initCookieIns = new InitCookie({
        entry_channel: this.getEntryChannel(),
    });
    /**
     * 用户最初进入的页面或入口
     */
    getEntryChannel() {
        return this.getAgentName();
    }
    /**
     * 用户在哪个页面赋权的
     * @returns
     */
    productSource() {
        return this.getAgentName();
    }

    async init() {
        return this.initCookieIns.init();
    }

    /**
     * 根据路由获取agent名称
     * @returns
     */
    getAgentName() {
        const hash = window.location.hash;
        if (hash?.includes('novelty-check-report')) {
            return 'ip_searching_novelty_search';
        }
        if (hash?.includes('fto-pro')) {
            return 'ip_searching_fto';
        }
        if (hash?.includes('design-fto')) {
            return 'ip_searching_design_fto';
        }
        // 这个是兜底
        return 'ip_searching';
    }

    /**
     * 赋权接口的参数 https://confluence.zhihuiya.com/pages/viewpage.action?pageId=272192900
     * @returns
     */
    getTrackingParams() {
        return {
            source: InitCookie.getCampaignName(),
            // 这个要从InitCookie上去,有可能其他团队存的,我这里取,不能支持接使用this.getEntryChannel()
            entry_channel: InitCookie.getEntryChannel(),
            product_source: this.productSource(),
        };
    }
}

export const initCookieService = new InitCookieService();
